import { z } from 'zod';
import { InboxConversationChannel, InboxConversationStatus } from '../../models';
export const inboxConversationParamsSchema = z.object({ conversationId: z.uuid() });
export const inboxConversationsQuerySchema = z.object({
    /** One or several. A single value arrives as a string, several as an array */
    statuses: z.union([z.enum(InboxConversationStatus), z.array(z.enum(InboxConversationStatus)).min(1)])
        .transform(value => Array.isArray(value) ? value : [value])
        .default([InboxConversationStatus.OPEN]),
    channel: z.enum(InboxConversationChannel).optional(),
    /** `me`, `unassigned` or a user id. Leave out for everyone's */
    assignee: z.union([z.literal(`me`), z.literal(`unassigned`), z.uuid()]).optional(),
    /** `true` for conversations with no contact matched yet */
    unmatched: z.enum([`true`, `false`]).optional(),
    search: z.string().trim().min(1).max(200).optional(),
    /** `nextCursor` from the previous page */
    before: z.string().trim().min(1).optional(),
    limit: z.coerce.number().int().min(1).max(100).default(25),
});
export const inboxConversationNoteBodySchema = z.object({
    content: z.string().trim().min(1).max(1500),
    mentionedUsers: z.array(z.uuid()).default([]).transform(mentionedUsers => Array.from(new Set(mentionedUsers))),
});
/** Null unassigns */
export const inboxConversationAssigneeBodySchema = z.object({ userId: z.uuid().nullable() });
export const inboxConversationContactBodySchema = z.object({ contactId: z.number().int().positive() });
//# sourceMappingURL=inboxConversation.js.map